<template>
	<!-- コンテンツ -->
  <div id="content">
    <div id="common">
      <h1 class="widhlead">{{myTopCategory.name}}</h1><br>
      <div v-for="child in myTopCategory.child" v-bind:key="child.id">
        <h2>{{child.name}}</h2>
        <div v-if="child.child.length > 0">
          <div class="speclist">
            <img :src="categoryImage[child.id]" :alt="child.name" @error="onError">
            <ul>
              <div v-for="children in child.child" v-bind:key="children.id">
                <li>
                  <router-link :to="{name: 'list', params: {Id: children.id}}">{{children.name}}</router-link>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div v-else>
          <div class="speclist">
            <img :src="categoryImage[child.id]" :alt="child.name" @error="onError">
            <ul>
              <li>
                <router-link :to="{name: 'list', params: {Id: child.id}}">{{child.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        categoryImages: [],
        sortCategories: [],
        myTopCategory: [
          {
            'id': null,
            'name': null,
            'image': '',
            'child': [
              {
                'id': null,
                'name': null,
                'child': []
              }
            ]
          }
        ],
        categoryImage: {},
        kenki_image_path: process.env.VUE_APP_KENKI_IMAGE_PATH
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      if(this.categorySet.length>0){
        this.sortCategories = this.categorySet
        this.setMyTopCategory()
        for(var i=0; i<this.myTopCategory.child.length; i++){
          if(this.myTopCategory.child[i].child.length > 0){
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].child[0].id)
          }else{
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].id)
          }
        }
        this.$parent.category_id = this.myTopCategory.id
        this.$parent.active_page_name = ''
      }
    },
    methods: {
			onError: function () {
				event.target.src = this.kenki_image_path + 'noimage.jpg'
			},
      kenkiImagePath: function (product_code,n) {
        return this.kenki_image_path + product_code + '-' + ('00' + (n+1)).slice(-2) + '.jpg'
      },
      setMyTopCategory: function (){
        var target = this.myTopCategory
        var targetItems = []
        var specName = this.$route.params.Spec
        targetItems = this.sortCategories.filter(function(item){
          if((item.name).indexOf(specName)>=0) return true
        })
        target = targetItems[0]
        this.myTopCategory = target       
      },
      getImagePath: function (category_id, id) {
        var myId = id
        var url = process.env.VUE_APP_URL + '/stock_products/search'
        var myToken = process.env.VUE_APP_TOKEN
        var myComId = process.env.VUE_APP_COMPANY_ID
        var param = {}
        param = {
          'limit': 100,
          'stock_product': {
              'category_id': myId,
              'company_id': myComId
          }
        }
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
             'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          this.$set(this.categoryImage, category_id, this.kenkiImagePath(data[0].product.product_code,0))
        })
        .catch(e => console.error(e))
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
        this.setMyTopCategory()
        for(var i=0; i<this.myTopCategory.child.length; i++){
          if(this.myTopCategory.child[i].child.length > 0){
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].child[0].id)
          }else{
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].id)
          }
        }
        this.$parent.category_id = this.myTopCategory.id
        this.$parent.active_page_name = ''
      }
    }
    
  }
</script>
